export default __webpack_public_path__ + "static/media/ar.880c69d5.svg";